module.exports = __webpack_public_path__ + "static/Rocket-3471312014340f881a42a6ea75a8eb47.svg";